import {useTranslation} from "react-i18next";
import InformationDialog from "../../../common/dialog/InformationDialog";
import {SubmissionTranslKey} from "../SubmissionTranslKey";

export interface AuthorizationServiceUnavailableDialogProps {
    open: boolean;
    onClose: () => void;
}

export default function AuthorizationServiceUnavailableDialog(props: Readonly<AuthorizationServiceUnavailableDialogProps>) {
    const {open, onClose} = props;
    const {t} = useTranslation();

    return (
        <InformationDialog
            open={open}
            onClose={onClose}
            title={t(SubmissionTranslKey.AUTHORIZATION_SERVICE_UNAVAILABLE_DIALOG_TITLE)}
            primaryButton={{title: t(SubmissionTranslKey.GO_TO_DASHBOARD), onClick: onClose}}
        >
            {t(SubmissionTranslKey.AUTHORIZATION_SERVICE_UNAVAILABLE_DIALOG_MESSAGE)}
        </InformationDialog>
    );
}
